import styled from "styled-components"
import { Botao } from "../../styles"

export const Form = styled.form`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 48px;
`
export const Header = styled.header`
    margin-bottom: 40px;
    padding: 16px;

    h1 {
        margin-bottom: 24px;
        font-weight: normal;
    }

    h2 {
        font-weight: bold;
    }
`